import { render } from "./PropostaValores.vue?vue&type=template&id=2b70feae"
import script from "./PropostaValores.vue?vue&type=script&lang=js"
export * from "./PropostaValores.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__